import React, { useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './TermsAndConditions.module.css';
import { useNavigate } from 'react-router-dom';
import { Container } from '@bookingcom/bui-react';
import { Helmet } from 'react-helmet';
import { useTermsHtml } from './useTermsHtml';

const TermsAndConditionsFallback = () => {
  const { t } = useTranslation();
  const securityEmail = t('partner_terms_security_email');

  return (
    <>
      <h3>{t('partner_terms_business_partner_account_title')}</h3>
      <p className={styles.termsAndConditionsContent}>
        {t('partner_terms_business_partner_account_intro')}
      </p>

      <p className={styles.termsAndConditionsContent}>
        {t('partner_terms_prohibited_activities_intro')}
      </p>
      <ul className={styles.termsAndConditionsContent}>
        <li>{t('partner_terms_prohibited_activity_1')}</li>
        <li>{t('partner_terms_prohibited_activity_2')}</li>
        <li>{t('partner_terms_prohibited_activity_3')}</li>
        <li>{t('partner_terms_prohibited_activity_4')}</li>
        <li>{t('partner_terms_prohibited_activity_5')}</li>
        <li>{t('partner_terms_prohibited_activity_6')}</li>
        <li>{t('partner_terms_prohibited_activity_7')}</li>
        <li>{t('partner_terms_prohibited_activity_8')}</li>
        <li>{t('partner_terms_prohibited_activity_9')}</li>
        <li>{t('partner_terms_prohibited_activity_10')}</li>
      </ul>

      <p className={styles.termsAndConditionsContent}>
        <Trans
          i18nKey="partner_terms_security_reporting"
          values={{ email: securityEmail }}
          components={{
            email: <a href={`mailto:${securityEmail}`} />
          }}
        />
      </p>

      <p className={styles.termsAndConditionsContent}>
        {t('partner_terms_consequences_non_compliance')}
      </p>

      <p className={styles.termsAndConditionsContent}>{t('partner_terms_booking_com_signature')}</p>
    </>
  );
};

const TermsAndConditions = () => {
  const { t } = useTranslation();
  const termsHtml = useTermsHtml();
  const navigate = useNavigate();
  const backButtonText = t('back_button');
  const headerRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headerRef.current?.focus();
  }, []);

  return (
    <div data-testid="termsAndConditionsTestId">
      <Container centered className={styles.termsAndConditionsContainer}>
        <Helmet>
          <title>{'Terms & Conditions | Booking.com'}</title>
        </Helmet>
        <Container centered className={styles.termsContainer}>
          <button
            className={styles.backButton}
            onClick={() => navigate('/')}
            aria-label={backButtonText}>
            {/*<img className={styles.navLeftArrow} src={navLeft} />{' '}*/}
            <span className={styles.backButtonText}>{t('back_button')}</span>
          </button>
          <h2 ref={headerRef} tabIndex={-1} className={styles.termsAndConditionsHeading}>
            {t('terms_conditions_link')}
          </h2>
          {termsHtml ? (
            <div
              className={styles.termsAndConditionsHtml}
              data-testid="termsAndConditionsHtmlContent"
              dangerouslySetInnerHTML={{ __html: termsHtml }}
            />
          ) : (
            <TermsAndConditionsFallback />
          )}
        </Container>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
